import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <RankingSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
        <CarouselSection />
        <AboutSection />
        <FaqSection />
        <IndexSection />
        <CardsSection />
        <TopicsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}